import { render } from "./AddTypeModal.vue?vue&type=template&id=7297ded6&ts=true"
import script from "./AddTypeModal.vue?vue&type=script&lang=ts"
export * from "./AddTypeModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__